import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import { SchoolModuleBatch, SchoolModuleEvent } from 'src/app/models/module/moduledetails';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';

@Component({
  selector: 'app-modulestudentlist',
  templateUrl: './modulestudentlist.component.html',
  styleUrls: ['./modulestudentlist.component.css'],
})
export class ModulestudentlistComponent implements OnInit {
  constructor(
    public modulemanager: ModulemanagementService,
    public toastr: ToastrService,
    public headerinfo: ComponentheaderService,
    public router: ActivatedRoute,
    public route: Router
  ) {
    headerinfo.setHeaderDisplay(`Course Students' List`, [], []);
  }
  p: number = 1;
  students: any;
  stats: any;
  itemsPerPage = 25;
  totalItems: any;
  data: any;
  moduleid: number;
  allowBatches: false;
  moduleBatches: SchoolModuleBatch[] = [];
  batchFilterActions: AdminAction[] = [];
  //filteredStudents: any[];
  //activeFilterId: number = 0;
  selectedBatchId: number = 0;
  @ViewChild('actionslink') actionsLink: ElementRef;

  async ngOnInit() {
    // debugger;
    this.headerinfo.pageLoadingStarted(this);

    this.moduleid = this.router.snapshot.queryParams.moduleid;

    const schdata: any = await this.modulemanager
      .getModuleDetails(this.moduleid)
      .toPromise();

    let modulename = schdata.moduleinfo.name;
    //    debugger;
    this.headerinfo.setHeaderDisplay(
      `Module Students'`,
      [
        {
          displaytext: 'School',
          route: `/user/schoolhome`,
          //params: { moduleID: this.moduleid },
        },
        {
          displaytext: 'Course',
          route: `/user/moduledetails`,
          params: { moduleID: this.moduleid },
        },
        {
          displaytext: `Students`,
          route: `/user/modulestudentlist`,
          params: this.router.snapshot.queryParams,
        },
      ],
      []
    );

    //  this.modulemanager.getModuleStudent().;

    this.data = await this.modulemanager
      .getModuleStudents(this.moduleid, 1, this.itemsPerPage, this.selectedBatchId)
      .toPromise()
      .catch((err) => {
        this.toastr.error(err);
        this.route.navigate(['/user/moduledetails'], {
          queryParams: { moduleID: this.moduleid },
        });
        return;
      })
      .finally(() => this.headerinfo.pageLoadingDone(this));
    this.students = this.data.students;
    //this.filteredStudents = this.students;
    this.totalItems = this.data.studentcount;

    if (!this.students || this.students.length == 0) {
      this.toastr.error(`No Student enrolled`);
      this.route.navigate(['/user/moduledetails'], {
        queryParams: { moduleID: this.moduleid },
      });
      return;
    }

    this.allowBatches = schdata.allowBatches;
    if (this.allowBatches){
      this.moduleBatches = await this.modulemanager.getModuleBatches(this.moduleid).toPromise();

      let defaultBatchAction = new AdminAction();
      defaultBatchAction.displaytext = "All Batches";
      defaultBatchAction.params = {id: 0}
      this.batchFilterActions.push(defaultBatchAction);
      this.moduleBatches.forEach(b => {
        let obj = new AdminAction();
        obj.displaytext = b.name;
        //this is no longer needed because we're now using a regular dropdown, not admin actions
        //obj.callback = (id: number) => this.filterByBatch(id);
        obj.params = {id: b.id};
        if (!this.batchFilterActions.find(a => a.displaytext == b.name))
          this.batchFilterActions.push(obj);
      });
    }
    this.headerinfo.pageLoadingDone(this);
  }

  actionsDropdownClicked(){
    setTimeout((() => {
      if (this.actionsLink.nativeElement.getAttribute('aria-expanded') == 'true') {
        $(this.actionsLink.nativeElement.querySelector('i')).addClass('fa-caret-up');
        $(this.actionsLink.nativeElement.querySelector('i')).removeClass('fa-caret-down');
      }
      else {
        $(this.actionsLink.nativeElement.querySelector('i')).addClass('fa-caret-down');
        $(this.actionsLink.nativeElement.querySelector('i')).removeClass('fa-caret-up');
      }
    }).bind(this), 1);
  }

  setBatchId(id: any){
    this.selectedBatchId = id;
  }

  // filterByBatch(id: any){
  //   this.activeFilterId = id;
  //   if(id == 0){
  //     this.filteredStudents = this.students;
  //   }
  //   else{
  //     this.filteredStudents = this.students.filter(s => s['batchid'] == id);
  //   }
  // }

  async getPage(page) {
    this.data = await this.modulemanager
      .getModuleStudents(this.moduleid, page, this.itemsPerPage, this.selectedBatchId)
      .toPromise()
      .catch((err) => {
        this.toastr.error(err);
        this.route.navigate(['/user/moduledetails'], {
          queryParams: { moduleID: this.moduleid },
        });
        return;
      })
      .finally(() => this.headerinfo.pageLoadingDone(this));

    this.students = this.data.students;
    this.totalItems = this.data.studentcount;
  }

  export() {
    // this.modulemanager.downloadModuleStudentList(this.moduleid).subscribe();
    this.headerinfo.pageLoadingStarted(this);
    try {

    this.modulemanager
    .downloadModuleStudent(this.moduleid)
    .subscribe((response: any) => {
      const url = window.URL.createObjectURL(response);
      window.open(url);

    }),
    (error: any) => console.log('Error downloading the file'),
    () => console.info('File downloaded successfully');
    } catch (error) {

    }finally{
      this.headerinfo.pageLoadingDone(this);
    }
  }
}
